<div class="shapes-container">
  <!-- Animated SVG Shapes -->
  <div class="animated-shapes">
    @for (shape of shapes; track shape.name; let i = $index) {
      <img
        [src]="shape.path"
        [@slideAndBounce]="{
          value: shape.state,
          params: { startPosition: shape.startPosition },
        }"
        [attr.height]="shape?.height"
        [attr.width]="shape?.width"
        (@slideAndBounce.done)="onAnimationComplete(i)"
        [style.animationDelay.s]="i * 0.3"
        [alt]="shape?.name" />
    }
  </div>
</div>
